@import '../../../globals/main.scss';

pn-link-list {
  .link-list__header {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.8rem;
  }

  .link-list__heading {
    margin-bottom: 0.8rem;

    @media screen and (min-width: $max-width-xl) {
      font-size: 3.2rem;
    }
  }

  .link-list__preamble {
    max-width: 85rem;
    text-align: center;
    margin-bottom: 0;

    @media screen and (min-width: $max-width-xl) {
      text-wrap: balance;
    }
  }

  .link-list {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;

    margin: 0;
    margin-bottom: 2.4rem;
    padding: 0;
  }

  .link-list__container {
    overflow-x: auto;
    text-align: center;
    white-space: nowrap;

    &.link-list__active {
      a,
      li,
      ul {
        cursor: grab;
        cursor: -webkit-grab;
      }
    }

    &::-webkit-scrollbar {
      height: 0.4rem;
      margin-top: 2rem;
      -webkit-appearance: none;

      @media screen and (min-width: $min-width-md) {
        height: 0.6rem;
      }
    }

    &::-webkit-scrollbar-thumb {
      background: $blue700;
      border-radius: 2rem;
    }

    &::-webkit-scrollbar-track {
      background: #d3cecb;
      border-radius: 2rem;
      width: 100%;
      margin: 0 5rem;

      @media screen and (min-width: $min-width-md) {
        margin: 0 10rem;
      }

      @media screen and (min-width: $max-width-xl) {
        margin: 0 15rem;
      }

      @media screen and (min-width: $max-width-xxl) {
        margin: 0 20rem;
      }
    }

    &::-webkit-resizer {
      display: none;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      height: 85%;
      width: 10%;
    }

    &::before {
      background: linear-gradient(270deg, rgba(255, 255, 255, 0) 50%, #fff 95%);
      left: 0;
    }

    &::after {
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 50%, #fff 95%);
      right: 0;
    }
  }

  .link-list__scrollable {
    display: inline-block;
    padding: 2rem 0 1rem;

    @media screen and (min-width: $min-width-lg) {
      padding: 0.5rem 2rem 1rem;
    }
  }

  [slot='linklist'] {
    ul {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0 1.6rem;
    }

    li {
      & > a {
        display: block;
        color: $gray900;
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 140%;
        text-decoration: none;
        cursor: pointer;

        background-color: $white;
        border: 0.1rem solid $gray200;
        border-radius: 0.8rem;
        margin: 0 0.8rem;
        padding: 1rem;

        @media screen and (min-width: 1410px) {
          font-size: 1.6rem;
        }

        &:hover,
        &:active,
        &:focus {
          color: #fff;
        }

        &:hover,
        &:focus {
          background-color: $blue700;
        }

        &:active {
          background-color: $blue900;
        }

        &:focus {
          outline: 2px solid $blue700;
          outline-offset: 2px;
        }
      }
    }
  }

  .link-list__button {
    display: flex;
    justify-content: center;
  }

  @-moz-document url-prefix() {
    .link-list__container {
      scrollbar-color: $blue700 #d3cecb;
    }

    .link-list__scrollable {
      padding: 0.5rem 2rem 2rem;
    }
  }
}
